import { motion } from 'framer-motion';
import { SITE } from '@/data';
import { EASE, Reveal } from './Reveal';

const BARS = [42, 68, 30, 82, 55, 90, 45, 72, 36, 62, 85, 50, 66, 40, 76, 32, 58, 80, 47, 70, 38, 64, 88, 52];

function PlayerCard({ index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, ease: EASE, delay: index * 0.08 }}
      whileHover={{ y: -5 }}
      className="flex flex-col gap-5 rounded-2xl border border-ivory/10 bg-plum-card p-5 transition-[border-color,box-shadow] duration-300 hover:border-gold/40 hover:shadow-[0_16px_44px_rgba(0,0,0,0.35)]"
      data-testid={`listen-player-${index + 1}`}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold text-plum">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <polygon points="7 4 20 12 7 20 7 4" />
          </svg>
        </span>
        <span className="text-right font-mono text-[11px] uppercase tracking-[0.18em] text-ivory/55">
          [SOUNDCLOUD PLAYLIST {String(index + 1).padStart(2, '0')}]
        </span>
      </div>
      <div className="flex h-12 items-end gap-[3px]" aria-hidden="true">
        {BARS.map((h, i) => (
          <motion.span
            key={i}
            className={`w-full max-w-[7px] flex-1 rounded-full ${i % 3 === 0 ? 'bg-gold' : 'bg-gold/45'}`}
            style={{ height: `${h}%` }}
            initial={{ scaleY: 0.3, transformOrigin: 'bottom' }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5, ease: EASE, delay: 0.2 + i * 0.015 }}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default function Listen() {
  return (
    <section id="listen" className="mx-auto max-w-[1280px] scroll-mt-24 px-6 pt-24 md:pt-32" data-testid="listen-section">
      <Reveal>
        <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
          <div>
            <span className="font-mono text-[13px] font-bold uppercase tracking-[0.25em] text-gold">Every Top 10, on repeat</span>
            <h2 className="mt-3 font-display text-5xl uppercase leading-[0.95] text-ivory md:text-7xl">
              PRESS <span className="text-gold">PLAY</span>
            </h2>
          </div>
          <p className="max-w-[380px] text-lg text-ivory/65">
            Every Top 10 as a playlist, plus Nyah's own mixes.
          </p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
        {SITE.soundcloud.map((url, i) =>
          url ? (
            <Reveal key={i} delay={i * 0.08}>
              <iframe
                title={`SoundCloud player ${i + 1}`}
                loading="lazy"
                allow="autoplay"
                className="h-[166px] w-full rounded-2xl border border-ivory/10 bg-plum-card"
                src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23e8b86a&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&visual=false`}
                data-testid={`listen-player-${i + 1}`}
              />
            </Reveal>
          ) : (
            <PlayerCard key={i} index={i} />
          )
        )}
      </div>
    </section>
  );
}
